import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AnnouncerProvider } from './a11y/announce';
import { PreferencesProvider } from './a11y/preferences';
import { SessionProvider } from './auth/session';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PreferencesProvider>
      <SessionProvider>
        <AnnouncerProvider>
          <App />
        </AnnouncerProvider>
      </SessionProvider>
    </PreferencesProvider>
  </StrictMode>,
);

/**
 * Register the service worker so the app can be installed.
 *
 * Deliberately after load: registration competes with the first render for
 * bandwidth otherwise, and an install prompt is worth nothing if the page it
 * offers to install was slow to appear.
 *
 * Registration failing is not an error worth surfacing. The site works exactly
 * as before without it; only installability and the offline notice are lost.
 */
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    const base = import.meta.env.BASE_URL || '/';
    navigator.serviceWorker
      .register(`${base}sw.js`, { scope: base })
      .catch(() => { /* not installable here; the app is unaffected */ });
  });
}
